import type { BillingCurrency } from "../../services/billingApi";

type CurrencyToggleProps = {
  currency: BillingCurrency;
  onChange: (currency: BillingCurrency) => void;
};

const OPTIONS: { value: BillingCurrency; label: string }[] = [
  { value: "LKR", label: "LKR" },
  { value: "USD", label: "USD" },
];

/**
 * Manual override for the server's country-based currency routing (LK → LKR,
 * elsewhere → USD). Useful when geolocation headers are missing or the visitor
 * simply prefers the other currency.
 */
export default function CurrencyToggle({
  currency,
  onChange,
}: CurrencyToggleProps) {
  return (
    <div
      role="group"
      aria-label="Billing currency"
      className="inline-flex rounded-xl border border-gray-200 bg-gray-50 p-1"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={currency === option.value}
          onClick={() => onChange(option.value)}
          className={`rounded-lg px-3 py-1.5 text-xs font-bold transition-all ${
            currency === option.value
              ? "bg-white text-indigo-700 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
